<template>
    <ui-field v-bind="this.$props" v-slot="{ id }">
        <autoresizable-textarea :enabled="autoresize" ref="autoresizable-textarea">
            <textarea 
                :id="id"
                class="m-0 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500"
                :class="[dynamicClasses, field]"
                :name="name"
                :placeholder="placeholder"
                :autofocus="autofocus"
                :required="required"
                :disabled="disabled"
                :rows="rows"
                :value="value"
                @input="$emit('input', $event.target.value)"
                @change="$emit('change', $event.target.value)"
                @blur="$emit('blur', $event.target.value)"
            ></textarea>
        </autoresizable-textarea>
    </ui-field>
</template>

<script>
export default {
    props: {
        value: null,
        label: String,
        name: String,
        error: String,
        warning: String,
        info: String,
        placeholder: String,
        autofocus: Boolean,
        required: Boolean,
        disabled: Boolean,
        autoresize: Boolean,
        field: String,
        rows: {
            default: '3',
        },
    },
    data() {
        return {};
    },
    computed: {
        dynamicClasses () {
            if (this.error) return 'border-red-300'
            if (this.disabled) return 'border-gray-300 text-gray-500 bg-gray-50'
            return 'border-gray-300 placeholder-gray-400'
        }
    },
    methods: {
        resize() {
            this.$refs['autoresizable-textarea'].forceResize()
        },
    }
}
</script>
